import React from 'react'

function Mac() {
  return (
    <div><br /><br /><br /><br />
        <h1 align='center'><b>MAC Page</b> </h1><br />
    </div>
  )
}

export default Mac